/**
 * Shared phone validation aligned with backend InternationalPhoneNumber rule:
 * optional + followed by 7–15 digits, or 7–15 digits without +.
 */
export const PHONE_REGEX = /^\+?\d{7,15}$/;

export const PHONE_VALIDATION_MESSAGE =
    'Must be a valid phone number (e.g. +1234567890 or 7–15 digits)';

/** Clean as backend: keep only digits and leading + */
function cleanPhoneInput(value: string): string {
    const cleaned = value.replace(/[^\d+]/g, '');
    return cleaned.startsWith('+') ? cleaned : cleaned;
}

export function isValidPhoneFormat(value: string | undefined | null): boolean {
    if (value == null || value === '') return true;
    const cleaned = cleanPhoneInput(value);
    return PHONE_REGEX.test(cleaned);
}
